<template>
  <section class="hero">
    <div class="hero-body">
      <div class="container" v-if="restaurant">
        <div class="columns">
          <div class="column is-narrow">
            <h1 class="title">
              {{ restaurant.name }}
              <a class="mwf-link" v-if="restaurant.link" :href="restaurant.link" target="_blank">
                <span class="icon">
                  <font-awesome-icon icon="external-link-alt" />
                </span>
              </a>
              <!-- TODO want these buttons next to the title, but if they
              have to wrap, they should wrap together -->
              <button class="button is-white" @click="routeEditFoodItem({ type: 'Restaurant', id })">
                <b-icon
                  pack="fas"
                  icon="pencil-alt"
                  size="is-small" />
              </button>
              <button class="button is-white" @click="deleteRestaurant">
                <b-icon
                  pack="fas"
                  icon="trash-alt"
                  size="is-small" />
              </button>
            </h1>
            <h2 class="subtitle">Restaurant</h2>
            <div class="tags">
              <span v-for="cat in restaurant.categories" :key="cat" class="tag is-info">
                {{cat}}
              </span>
            </div>
            <div>
              <a v-if="restaurant.address && restaurant.address.city" :href="addrHref(restaurant)" target="_blank">{{addrString(restaurant.address)}}</a>
              <template v-else>{{addrString(restaurant.address)}}</template>
            </div>
          </div>
          <div class="column">
            <div style="white-space: pre-line">
              {{restaurant.description}}
            </div>
          </div>
        </div>
        <hr>
      </div>

      <!-- Invalid restaurant id -->
      <div class="container" v-else-if="error">
        <h1 class="title">Invalid restaurant id</h1>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import linksMixin from '@/mixins/links';
import routingMixin from '@/mixins/routing';
import notifyMixin from '@/mixins/notify';

export default {
  name: 'restaurant',
  mixins: [linksMixin, routingMixin, notifyMixin],
  data() {
    return {
      error: null,
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  watch: {
    $route() {
      this.fetchRestaurant();
    },
  },
  mounted() {
    this.fetchRestaurant();
  },
  methods: {
    fetchRestaurant() {
      return this.$store.dispatch('restaurant/fetchRestaurant', this.id).catch((err) => {
        this.error = err.message;
      });
    },
    deleteRestaurant() {
      this.$dialog.confirm({
        title: 'Delete Restaurant',
        message: 'Are you sure?',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$store.dispatch('restaurant/deleteRestaurant', this.id)
          .then(() => this.routeBrowse({ noBack: true }))
          .catch((err) => {
            this.error = err.message;
          });
        },
      });
    },
  },
  computed: {
    ...mapGetters('restaurant', ['restaurant']),
  },
  components: {
    FontAwesomeIcon,
  },
};
</script>

<style lang="sass" scoped>
// TODO this is the same as in Recipe.vue
.mwf-link
  font-size: 1.1rem
  vertical-align: super

.mwf-desc
  max-height: 6rem
  overflow: auto


</style>


// WEBPACK FOOTER //
// src/components/restaurant/Restaurant.vue